<template>
	<div class="pages">
		<sub-ibox-title :is-show-back = false><p slot="title">营销工具</p></sub-ibox-title>
		<section class="list-cont">
			<div>
				<ul class="fx fx-wrap">
					<router-link :to="{ name: 'promotionList' }" tag="li">
						<span class="icon-full-cut"></span>
						<p>满减活动管理</p>
					</router-link>
					<router-link :to="{ name: 'redPacketList' }" tag="li">
						<span class="icon-red-packet"></span>
						<p>裂变红包管理</p>
					</router-link>
					<router-link :to="{ name: 'couponList' }" tag="li">
						<span class="icon-coupon"></span>
						<p>优惠券管理</p>
					</router-link>
					<!--<router-link :to="{ name: 'redPacket' }" tag="li">
						<span class="icon-red-packet"></span>
						<p>裂变红包管理</p>
					</router-link>-->
					<!--
					<router-link :to="{ name: 'redPacket' }" tag="li">
						<span class="icon-red-packet"></span>
						<p>裂变红包管理</p>
					</router-link>
					<router-link :to="{ name: 'turntableList' }" tag="li">
						<span class="icon-turntable"></span>
						<p>抽奖管理</p>
					</router-link>-->
				</ul>
			</div>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'Marketing',
		components: {
		},
		data() {
			return {
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				//				list: state => state.adminMemberPublic.list
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.list-cont{
		background: $color-white;
		border: 1px solid $color-border;
		border-top: none;
		border-radius: 0 0 2px 2px;
		padding: px-em(40px);
		li {
			text-align: center;
			cursor: pointer;
			background: $color-white;
			border: 1px solid transparent;
			margin: 0 px-em(40px) px-em(40px);
			border-radius: 2px;
			position: relative;
			overflow: hidden;
			transition: all 0.25s ease;
			-webkit-transition: all 0.25s ease;
			span{
				display: inline-block;
				width: px-em(144px);
				height: px-em(144px);
				line-height: px-em(144px);
				text-align: center;
				font-size: px-em(110px) !important;
				margin: px-em(40px);
				margin-bottom: 0;
			}
			p{
				padding: px-em(20px) 0;
			}
			&:hover{
				border-color: $color-main;
			}
			/*定义色彩*/
			.icon-full-cut{
				color: $color-orange;
			}
			.icon-coupon{
				color: $color-yellow;
			}
			.icon-red-packet{
				color: $color-red;
			}
			.icon-turntable{
				color: $color-plum-red;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Index.vue?5028b4e3